import React, {useContext, useEffect, useState} from 'react';
import ItemIcon from '../ItemIcon';
import {useParams} from 'react-router-dom';
import 'styles/item/ItemDetail.css';
import BuyTab from 'components/items/detail/BuyTab';
import SellTab from 'components/items/detail/SellTab';
import {MarketContext} from 'util/market/MarketContext';
import itemTypeToEmoji from 'util/itemTypeToEmoji';
import {centsToString} from 'util/cashFormatter';
import itemRarityColors from 'util/itemRarityColors';
import TradeGraphs from 'components/items/detail/TradeGraphs';
import {useSessionConfiguration} from 'util/SessionConfigurationContext'; // Importing the new utility

const ItemDetail = () => {
    const [loading, setLoading] = useState(false);
    const {item, type} = useParams();
    const [selectedTab, setSelectedTab] = useState(type === 'graph' ? 'DETAILS' : (type === 'my-items' ? 'SELL' : 'BUY'));
    const {allItems} = useContext(MarketContext);
    const {isDesktopView} = useSessionConfiguration();

    const itemDetails = allItems.find((i) => i.itemType === item);

    useEffect(() => {
        if (allItems.length > 0) {
            setLoading(false);
        }
    }, [allItems]);

    if (loading || !itemDetails) return <div>Loading...</div>;

    // Use the rarityColors utility to get the colors and tooltip
    const {textColor, backgroundColor, tooltip} = itemRarityColors(itemDetails);

    return (
        <div className="main-content-body-padding">
            {isDesktopView && (
                <div className="floating-back-arrow">
                    <img width="48px" src="/images/item-detail-back-arrow.svg" alt="back arrow"
                         onClick={() => window.history.back()}/>
                </div>
            )}
            <h1 style={{textAlign: 'center', marginTop: '0'}}>{itemTypeToEmoji[item].translation.toUpperCase()}</h1>

            <div className="item-detail-top">
                <div className="item-icon-container">
                    <ItemIcon lootItem={item} textSize={5}/>
                    <div
                        style={{color: textColor}}
                        className="item-detail-rarity-holder"
                        data-tooltip-id="main-tooltip"
                        data-tooltip-content={tooltip}
                    >
                        {itemTypeToEmoji.getRarity(item)}
                    </div>
                </div>
                <div className="item-stats">
                    <p>Owned: {itemDetails.getUserQuantity()}</p>
                    <p>Overall count: {itemDetails.getMarketQuantity()}</p>
                    {
                        itemDetails.getMarketSo() && (
                            <p>Price: {centsToString(itemDetails.getMarketSo())}</p>
                        )
                    }
                </div>
            </div>
            <div className="item-detail-buttons">
                <button
                    className={selectedTab === 'SELL' ? 'active' : ''}
                    style={selectedTab === 'SELL' ? {backgroundColor: backgroundColor} : {}}
                    onClick={() => setSelectedTab('SELL')}
                >
                    SELL
                </button>
                <button
                    className={selectedTab === 'BUY' ? 'active' : ''}
                    style={selectedTab === 'BUY' ? {backgroundColor: backgroundColor} : {}}
                    onClick={() => setSelectedTab('BUY')}
                >
                    BUY
                </button>
                <button
                    className={selectedTab === 'DETAILS' ? 'active' : ''}
                    style={selectedTab === 'DETAILS' ? {backgroundColor: backgroundColor} : {}}
                    onClick={() => setSelectedTab('DETAILS')}
                >
                    DETAILS
                </button>
            </div>

            <div
                className="item-detail-content"
                style={{
                    backgroundColor: backgroundColor,
                    borderRadius: selectedTab === 'SELL' ? '0 10px 10px 10px' :
                        selectedTab === 'BUY' ? '10px' :
                            '10px 0 10px 10px'
                }}
            >
                {selectedTab === 'SELL' && <SellTab item={itemDetails}/>}
                {selectedTab === 'BUY' && <BuyTab item={itemDetails}/>}
                {selectedTab === 'DETAILS' && (<TradeGraphs item={item}/>)}
            </div>

        </div>
    );
};

export default ItemDetail;
